'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'textinput',
    elem: 'icon',
    mods: function mods(_ref) {
        var side = _ref.side;

        return { side: side };
    },
    render: function render() {
        var block = this.block,
            elem = this.elem,
            _props = this.props,
            children = _props.children,
            mix = _props.mix;

        if (children) {
            return _react2.default.cloneElement(children, {
                mix: [{ block: block, elem: elem, mods: this.mods(this.props) }, mix]
            });
        }
    }
});